import ReadMoreText from '@ui-framework/components/UI/ReadMoreText';
import { DATE_FORMAT } from '@ui-framework/index';
import dayjs from 'dayjs';
import Currency from '../../../Currency';

function claimNumber(original) {
  return original?.claimNumber || '*****';
}

function serviceCompletionDate(original) {
  return original?.serviceCompletionDate
    ? dayjs(original?.serviceCompletionDate).format(DATE_FORMAT.MEDIUM_DATE)
    : '';
}

function serviceProvider(original) {
  return original?.serviceProvider?.accountNumber || '*****';
}

function servicePerformed(original) {
  return <ReadMoreText>{original?.servicePerformed}</ReadMoreText>;
}

function totalApproved(original) {
  return <Currency>{original?.totalApproved}</Currency>;
}

export {
  claimNumber,
  serviceCompletionDate,
  serviceProvider,
  servicePerformed,
  totalApproved,
};
